import { ROUTES } from '@/constants/routes';
import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WireRecipientDeleteCancelDialog from '../WireRecipientDeleteCancelDialog';
import { SVButton } from '@/components/core';

type WireRecipientManageMenuProps = {
  customerId: string;
  uuid: string;
  name: string;
  isWireRecipient?: boolean;
  canDelete?: boolean;
  canCancel?: boolean;
};

export default function WireRecipientManageMenu({
  customerId,
  uuid,
  name,
  isWireRecipient = false,
  canDelete = false,
  canCancel = false,
}: WireRecipientManageMenuProps) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SVButton onClick={handleClick}>Manage</SVButton>
      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              minWidth: 150,
            },
          },
        }}>
        <MenuItem
          onClick={() =>
            navigate(
              `${ROUTES.CUSTOMERS}/${customerId}${isWireRecipient ? ROUTES.WIRE_RECIPIENTS : ROUTES.WIRE_REQUESTS}/${uuid}`,
            )
          }>
          View
        </MenuItem>
        {canDelete && (
          <MenuItem
            onClick={() => {
              setOpen(true);
              setIsDelete(true);
            }}>
            Delete
          </MenuItem>
        )}
        {canCancel && (
          <MenuItem
            onClick={() => {
              setOpen(true);
              setIsDelete(false);
            }}>
            Cancel
          </MenuItem>
        )}
      </Menu>
      <WireRecipientDeleteCancelDialog
        uuid={uuid}
        name={name}
        isDelete={isDelete}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
}
